import { createContext } from 'react';

// Where the pane is in a Doc Assistant capture; drives the Assign with ACE button and the search skeleton.
export const CAPTURE_STATUS = Object.freeze({
  // Nothing is running; the button can start an On Demand capture.
  IDLE: 'idle',
  // Automatic is on and the email is recent, but its capture has not started yet; checked until it starts or the wait window ends.
  WAITING: 'waiting',
  // A capture is under way and no file has matched a matter yet; the search view shows skeletons.
  SEARCHING: 'searching',
  // The first match moved the pane to the documents view; polling continues for files still in the pipeline.
  MATCHED: 'matched',
  // Assign finished; refreshing until every matched file shows saved, within a retry budget.
  SETTLING: 'settling',
  // The capture finished without an auto-assigned matter; files are parked for the user to place.
  NO_MATTER: 'noMatter',
});

// Shared Doc Assistant capture state, provided by SaveToContainer so the poll loop persists across the
// search <-> selected-record navigation a match triggers. Consumers: the Assign with ACE button and the
// search view's "Searching matters with ACE" skeleton.
export const DocAssistantCaptureContext = createContext({
  status: CAPTURE_STATUS.IDLE,
  banner: null,
  startCapture: () => {},
  dismissBanner: () => {},
});
